import * as React from 'react';

export const NotFoundPage = () => (
  <div className="card">
    <div className="card-body">
      <h5 className="card-title">Page Not Found</h5>
    </div>
  </div>
);
